    /*
    I wanted to take a stab at writing my own jQuery function that could be used easily in multiple places on the page, allowing different settings in each instance. So, without further ado...
    
    */
    import $ from 'jquery';
    $.fn.langSelector = function(options) {
        var el = this;
        var settings = $.extend({
            defaultText: 'โครงการที่สนใจ',
            cssClassName: 'prettydrop',
            hideOnSelect: true
        }, options);
        
        var countries = {
            pf1: {
                name: 'เพอร์เฟค มาสเตอร์พีซ (The Signature)',
            },
            pf2: {
                name: 'เลค เลเจนด์',
            },
            pf3: {
                name: 'เพอร์เฟค มาสเตอร์พีซ',
            },
            pf4: {
                name: 'เพนตัน',
            },
            pf5: {
                name: 'เบลล่า',
            },
            pf6: {
                name: 'เดอะ สกาย',
            },
            pf7: {
                name: 'เลค เลเจนด์ แจ้งวัฒนะ',
            }
        };
        var props = {
            isOpen: false
        };
        var methods = (function() {
            var wrapper,
                trigger,
                dropdown,
                dropdownList,
                listItems = [];
            
            return {
                init: function() {
                    methods.createDropdown();
                },
                createDropdown: function() {
                    el.addClass(settings.cssClassName + '__original');
                    wrapper = $('<div />', {
                        class: settings.cssClassName + '__wrapper'
                    });
                    trigger = $('<span />', {
                        class: settings.cssClassName + '__trigger',
                        text: settings.defaultText !== false ? settings.defaultText : el.text()
                    });
                    dropdown = $('<div />', {
                        class: settings.cssClassName + '__dropdown'
                    });
                    dropdownList = $('<ul />', {
                        class: settings.cssClassName + '__dropdown__list'
                    });
                    
                    for(var key in countries) {
                        if(! countries.hasOwnProperty(key)) {
                            return;
                        }
                        var country = countries[key];
                        var listItem = $('<li />', {
                            text: country.name
                        });
                        listItems.push(listItem[0]);
                        listItem.appendTo(dropdownList);
                        
                        methods.itemBinding(listItem);
                    }
                    
                    trigger.appendTo(wrapper);
                    dropdownList.appendTo(dropdown);
                    dropdown.appendTo(wrapper);
                    wrapper.insertAfter(el);
                    trigger.on('click.langSelector', methods.toggleDropdown);
                    // methods.outClick
                    wrapper.on('click.langSelector', function(e) {
                        e.stopPropagation();
                    });
                },
                itemBinding: function(li) {
                    $(li).on('click.langSelector', function() {
                        $(listItems).not(li).removeClass('active');
                        $(li).addClass('active');
                        if(settings.hideOnSelect === true) {
                            setTimeout(methods.hideDropdown, 100);
                        }
                        trigger.html(li.html());
                    });
                },
                showDropdown: function() {
                    wrapper.addClass(wrapper[0].classList[0] + '--open');
                    $('html').on('click.langSelector', methods.hideDropdown);
                    props.isOpen = true;
                },
                hideDropdown: function() {
                    wrapper.removeClass(wrapper[0].classList[0] + '--open');
                    $('html').off('click.langSelector');
                    props.isOpen = false;
                },
                toggleDropdown: function() {
                    if(props.isOpen === true) {
                        methods.hideDropdown();
                    } else {
                        methods.showDropdown();
                    }
                }
            }
        })();
        
        return methods.init();
    };
    
    var app = (function() {
        var _self = this; // Scope
        
        return {
            init: function() {     
                $('#language').langSelector({
                    defaultText: 'โครงการที่สนใจ'
                });
            }
        };
    })();
    
    $(function() {
        app.init();
    });